import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthorizationError } from '../contexts/AuthorizationErrorContext';

interface AuthorizationErrorBoundaryProps {
  children: React.ReactNode;
}

const AuthorizationErrorBoundary: React.FC<AuthorizationErrorBoundaryProps> = ({ children }) => {
  const navigate = useNavigate();
  const { authError, clearAuthError } = useAuthorizationError();

  useEffect(() => {
    console.log('AuthorizationErrorBoundary: useEffect triggered, authError:', authError);
    
    if (authError) {
      console.log('AuthorizationErrorBoundary: 🚨 AUTHORIZATION ERROR DETECTED!');
      console.log('AuthorizationErrorBoundary: Error details:', authError);
      console.log('AuthorizationErrorBoundary: Preparing to navigate to /unauthorized');
      
      // Create URL params for the error page
      const errorParams = new URLSearchParams({
        error: authError.message,
        endpoint: authError.endpoint,
        provider: authError.provider,
        timestamp: authError.timestamp
      });
      
      const targetUrl = `/unauthorized?${errorParams.toString()}`;
      console.log('AuthorizationErrorBoundary: Target URL:', targetUrl);
      
      // Clear the error from context
      clearAuthError();
      console.log('AuthorizationErrorBoundary: Cleared auth error from context');
      
      // Navigate to the error page
      console.log('AuthorizationErrorBoundary: 🔄 NAVIGATING TO ERROR PAGE...');
      navigate(targetUrl);
      console.log('AuthorizationErrorBoundary: Navigation call completed');
    }
  }, [authError, navigate, clearAuthError]);

  console.log('AuthorizationErrorBoundary: Rendering children, current authError:', authError);
  return <>{children}</>;
};

export default AuthorizationErrorBoundary; 